import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function NumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const isInvalid = isNaN(control.value) || (typeof control.value === 'string' && !control.value.trim());

    return isInvalid ? { error: 'NaN!' } : null;
  };
}
